<template>
  <div v-if="hasUndoAccess && isRejectedPpa">
    <div class="quick-action" v-if="!isUndoConfirmationActive">
      <button class="button" @click="onUndo()" title="Click to undo the rejection of this PPA">
        <b-icon pack="fal" icon="undo" custom-size="fa-lg"></b-icon>
      </button>
    </div>
    <portal to="global-modal-portal" v-else>
        <b-modal :active.sync="isUndoConfirmationActive" :width="640" scroll="keep" :has-modal-card="true">
            <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">Confirm Undo PPA Rejection</p>
            </header>
            <section class="modal-card-body">
                <div v-if="isError">
                <p v-if="serverErrors.length > 0" ref="generalErrorBlock">
                    <b class="title is-7 is-paddingless">Please correct the following error(s):</b>
                    <ul class="errors">
                    <li v-for="error in serverErrors" :key="error.errorMessage">{{ error.errorMessage }}</li>
                    </ul>
                    <br/>
                </p>

                <p v-if="serverErrorMessage.length">
                    <ul class="errors">
                    <li>{{ serverErrorMessage }}</li>
                    </ul>
                    <br/>
                </p>
                </div>
                <div v-else>
                    <p>Are you sure you wish to undo the rejection of PPA stock# <a @click.stop.prevent="onStockNoClick(inventoryItem)"><span class="has-text-weight-semibold">{{ inventoryItem.stockNo }}</span></a>? It will be reopened for appraisal.</p>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-danger" :class="{'is-loading': isSaving}" :disabled="isSaving || isError" @click="onConfirmUndo()">Confirm</button>
                <button class="button" @click="onCancelUndo">Cancel</button>
            </footer>
            </div>
        </b-modal>
    </portal>
  </div>
</template>

<script>

import eventBus from '@/eventBus'
import inventoryService from '../../services/inventoryService'
import { createNamespacedHelpers } from 'vuex'
const mapUserGetters = createNamespacedHelpers('user').mapGetters

export default {
  name: 'UndoPpaRejectionAction',
  props: {
    inventoryItem: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isUndoConfirmationActive: false,
      isSaving: false,
      serverErrors: [],
      serverErrorMessage: ''
    }
  },
  methods: {
    onUndo: function () {
      this.serverErrorMessage = ''
      this.serverErrors = []
      this.isUndoConfirmationActive = true
    },
    onConfirmUndo: function () {
      this.isSaving = true
      inventoryService.undoPpaRejection(this.inventoryItem).then(response => {
        this.isSaving = false
        if (response.result === false) {
          this.serverErrors = response.errors || []
          this.serverErrorMessage = response.message || ''
          return
        }
        this.isUndoConfirmationActive = false
        this.$buefy.toast.open({
          duration: 2500,
          message: 'PPA rejection undone for stock no. ' + this.inventoryItem.stockNo,
          position: 'is-top',
          type: 'is-success'
        })
        eventBus.$emit('inventory-changed', [this.inventoryItem])
      }).catch((error) => {
        this.serverErrorMessage = (error && error.message) || 'An unexpected error occurred.'
        this.isSaving = false
      })
    },
    onCancelUndo: function () {
      this.isUndoConfirmationActive = false
    },
    onStockNoClick: function (inventoryItem) {
      let that = this

      if (inventoryItem && inventoryItem.stockNo !== '') {
        this.$copyText(inventoryItem.stockNo).then(
          function (e) {
            that.$buefy.toast.open({
              duration: 2500,
              message: 'Stock No. ' + inventoryItem.stockNo + ' copied to clipboard',
              position: 'is-top',
              type: 'is-info'
            })
          }, function (e) {
            that.$buefy.toast.open({
              duration: 2500,
              message: 'Could not copy stock no. to clipboard',
              position: 'is-top',
              type: 'is-warning'
            })
          }
        )
      }
    }
  },
  computed: {
    ...mapUserGetters(['hasFeatureAccess']),
    hasUndoAccess: function () {
      return this.hasFeatureAccess('inventory.modify.undo-ppa-rejection')
    },
    isRejectedPpa: function () {
      return this.inventoryItem !== null && this.inventoryItem.type === 'PpaClosed' && this.inventoryItem.status === 'Archived' && this.inventoryItem.ppaProposedCostRejected === true
    },
    isError: function () {
      return this.serverErrorMessage.length > 0 || this.serverErrors.length > 0
    }
  }
}

</script>

<style scoped>
  .content ul{
    list-style-type: none;
    margin-top: 0
  }

  .modal-card-head, .modal-card-foot{
    padding: 20px !important
  }
</style>
